import state from '@/store/modules/service/state'
import actions from '@/store/modules/service/actions'
import mutations from '@/store/modules/service/mutations'
import getters from '@/store/modules/service/getters'

export default {
  state,
  actions,
  mutations,
  getters
}
